// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bcm_a bhv_jx","ListItemIcon--empty":"bcm_b bhv_ff"};